// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ActionBtnCard_actionBtn__v83UG {
  border-bottom: 1px solid var(--border-tertiary, #e3eaf2);
  height: 50px;
  color: var(--text-primary, #1f2023);
  font-family: Poppins;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 138.462% */
  letter-spacing: -0.2px;
}

.ActionBtnCard_actionButton__F9230 {
  cursor: pointer;
  float: right;
  height: inherit;
  align-items: center;
  display: flex;
}
.ActionBtnCard_actionButton__F9230 span {
  padding: 0 5px;
}
.ActionBtnCard_actionButton__F9230 .ActionBtnCard_actionViewMore__5Lzoe {
  cursor: pointer;
}

.ActionBtnCard_actionName__kPU8y {
  width: 700px;
}

.ActionBtnCard_actionExtension__w3VBT {
  cursor: pointer;
}
.ActionBtnCard_actionExtension__w3VBT span {
  display: flex;
}
.ActionBtnCard_actionExtension__w3VBT span svg {
  margin: 0px 3px;
}
.ActionBtnCard_actionExtension__w3VBT span svg:first-child {
  align-self: center;
}

.ActionBtnCard_status__kVIvD {
  min-width: 22px;
}

@media only screen and (max-width: 1440px) {
  .ActionBtnCard_actionName__kPU8y {
    width: 500px;
  }
}
@media only screen and (max-width: 1150px) {
  .ActionBtnCard_actionName__kPU8y {
    width: 300px;
  }
}
@media only screen and (max-width: 760px) {
  .ActionBtnCard_actionBtn__v83UG {
    display: flex;
    align-items: center;
    height: unset;
    padding: 10px 0;
  }
  .ActionBtnCard_actionName__kPU8y {
    width: unset;
    flex: 1 1;
    margin-right: 20px;
  }
  .ActionBtnCard_actionExtension__w3VBT {
    width: 150px;
  }
  .ActionBtnCard_actions__UWLJW {
    display: none;
  }
}
@media only screen and (max-width: 380px) {
  .ActionBtnCard_actionExtension__w3VBT {
    width: unset;
    flex: 1 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Sidecar/ActionBtnCard/ActionBtnCard.module.scss"],"names":[],"mappings":"AAAA;EACC,wDAAA;EACA,YAAA;EACA,mCAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,sBAAA;AACD;;AACA;EACC,eAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;AAED;AADC;EACC,cAAA;AAGF;AADC;EACC,eAAA;AAGF;;AACA;EACC,YAAA;AAED;;AAAA;EAUC,eAAA;AAND;AAHC;EACC,aAAA;AAKF;AAJE;EACC,eAAA;AAMH;AAJE;EACC,kBAAA;AAMH;;AAAA;EACC,eAAA;AAGD;;AADA;EACC;IACC,YAAA;EAIA;AACF;AADA;EACC;IACC,YAAA;EAGA;AACF;AAAA;EACC;IACC,aAAA;IACA,mBAAA;IACA,aAAA;IACA,eAAA;EAEA;EACD;IACC,YAAA;IACA,SAAA;IACA,kBAAA;EACA;EAED;IACC,YAAA;EAAA;EAGD;IACC,aAAA;EADA;AACF;AAIA;EACC;IACC,YAAA;IACA,SAAA;EAFA;AACF","sourcesContent":[".actionBtn {\n\tborder-bottom: 1px solid var(--border-tertiary, #e3eaf2);\n\theight: 50px;\n\tcolor: var(--text-primary, #1f2023);\n\tfont-family: Poppins;\n\tfont-size: 13px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 18px; /* 138.462% */\n\tletter-spacing: -0.2px;\n}\n.actionButton {\n\tcursor: pointer;\n\tfloat: right;\n\theight: inherit;\n\talign-items: center;\n\tdisplay: flex;\n\tspan {\n\t\tpadding: 0 5px;\n\t}\n\t.actionViewMore{\n\t\tcursor: pointer;\n\t}\n}\n\n.actionName {\n\twidth: 700px;\n}\n.actionExtension {\n\tspan{\n\t\tdisplay: flex;\n\t\tsvg{\n\t\t\tmargin: 0px 3px;\n\t\t}\n\t\tsvg:first-child{\n\t\t\talign-self: center;\n\t\t}\n\t}\n\tcursor: pointer;\n\t\n}\n.status{\n\tmin-width:22px\n}\n@media only screen and (max-width: 1440px) {\n\t.actionName {\n\t\twidth: 500px;\n\t}\n}\n\n@media only screen and (max-width: 1150px) {\n\t.actionName {\n\t\twidth: 300px;\n\t}\n}\n\n@media only screen and (max-width: 760px) {\n\t.actionBtn {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\theight: unset;\n\t\tpadding: 10px 0;\n\t}\n\n\t.actionName {\n\t\twidth: unset;\n\t\tflex: 1;\n\t\tmargin-right: 20px;\n\t}\n\n\t.actionExtension {\n\t\twidth: 150px;\n\t}\n\n\t.actions {\n\t\tdisplay: none;\n\t}\n}\n\n@media only screen and (max-width: 380px) {\n\t.actionExtension {\n\t\twidth: unset;\n\t\tflex: 1;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actionBtn": `ActionBtnCard_actionBtn__v83UG`,
	"actionButton": `ActionBtnCard_actionButton__F9230`,
	"actionViewMore": `ActionBtnCard_actionViewMore__5Lzoe`,
	"actionName": `ActionBtnCard_actionName__kPU8y`,
	"actionExtension": `ActionBtnCard_actionExtension__w3VBT`,
	"status": `ActionBtnCard_status__kVIvD`,
	"actions": `ActionBtnCard_actions__UWLJW`
};
export default ___CSS_LOADER_EXPORT___;
